import {
    getMerchantPayoutFilesSettlementXLS,
    getMerchantPayoutSummaryFilesTransactionCSV
} from "features/merchantPayouts/api";
import { ActionRequestHandlers, MenuActions } from "ui/widgets/Table";

export default function useSummaryFilesActions() {
    const getMenuItems = () => [
        MenuActions.SettlementXLS,
        MenuActions.TransactionsCSV
    ];

    const getRequestMappings = () =>
        new Map<MenuActions, ActionRequestHandlers>([
            [MenuActions.SettlementXLS, { menu: getMerchantPayoutFilesSettlementXLS }],
            [MenuActions.TransactionsCSV, { menu: getMerchantPayoutSummaryFilesTransactionCSV }],
        ]);

    return {
        getMenuItems,
        getRequestMappings
    };
};
